// i18n
import { i18n } from '@ecg-marktplaats/js-react-i18n';
import { fr as dateLocale } from 'date-fns/locale/fr';
import translation from '../../../../locales/fr-BE/translation.json';
import common from '../../../../locales/fr-BE/common.json';
import priceTypes from '../../../../locales/fr-BE/priceTypes.json';
import p2pPaymentsUi from '@ecg-marktplaats/p2p-payments-ui/locales/fr-BE.json';
import reviewsDialogUi from '@ecg-marktplaats/reviews-dialog-ui/locales/fr-BE.json';
import favouritesUi from '@ecg-marktplaats/favourites-ui/locales/fr-BE.json';

export default i18n.init({
  lng: 'fr-BE',
  dateLocale,
  translations: {
    translation,
    common,
    priceTypes,
    p2pPaymentsUi,
    reviewsDialogUi,
    favouritesUi,
  },
});
